import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import GeoSeo360 from "@/pages/servicios/GeoSeo360";

export const Route = createFileRoute("/servicios/geo-seo-360")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "GEO y visibilidad en respuestas de IA | SEOEVOLUTION" },
      { name: "description", content: "GEO para empresas: base SEO, contenido útil y observación de menciones y fuentes en respuestas generativas. Disponibilidad a consultar y mínimo de 6 meses." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/geo-seo-360" },
      { property: "og:title", content: "GEO y visibilidad en respuestas de IA | SEOEVOLUTION" },
      { property: "og:description", content: "GEO para empresas: base SEO, contenido útil y observación de menciones y fuentes en respuestas generativas. Disponibilidad a consultar y mínimo de 6 meses." },
      { name: "twitter:title", content: "GEO y visibilidad en respuestas de IA | SEOEVOLUTION" },
      { name: "twitter:description", content: "GEO para empresas: base SEO, contenido útil y observación de menciones y fuentes en respuestas generativas. Disponibilidad a consultar y mínimo de 6 meses." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/geo-seo-360" }],
    scripts: serviceSchemaScripts("geo-seo-360"),
  }),
  component: GeoSeo360,
});
